import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#000000',
    borderBottom: `1px solid${theme.palette.grey.main}`,
    width: '100%',
  },
}));

export default useStyles;
